@use '../../../../../styles/Colors.scss' as Colors;
@use '../../../../../styles/Constants.scss' as Constants;

.crew-lead-indicator {
	display: inline-block;
	width: 4px;
	height: 4px;
	background-color: #000;
	margin-right: 4px;
	flex-shrink: 0;
	vertical-align: middle;
}

.crew-lead-tooltip {
	text-align: center;

	&__title {
		font-weight: 700;
	}
}